export default {
      id: "ic_check_main_green-usage",
      viewBox: "0 0 15 12",
      url: "/" + "images/icons.3.109.2.svg#ic_check_main_green-usage",
      toString: function () {
        return this.url;
      }
    }